var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F9FF",
    d: "M49.92 61.44h-38.4C5.157 61.44 0 56.283 0 49.92v-38.4C0 5.157 5.157 0 11.52 0h38.4c6.363 0 11.52 5.157 11.52 11.52v38.4c0 6.363-5.157 11.52-11.52 11.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    fillRule: "nonzero",
    stroke: "#4A90E2",
    strokeWidth: 0.56,
    d: "M37.76 24.32h-19.2c-1.768 0-3.2 1.433-3.2 3.2v15.36c0 1.768 1.432 3.2 3.199 3.2h19.2c1.768 0 3.2-1.432 3.2-3.2V27.52c.002-1.767-1.432-3.2-3.198-3.2h0zm-.64 19.2H19.2c-.707 0-1.28-.573-1.28-1.28V30.72H38.4v11.52c0 .707-.574 1.28-1.28 1.28h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    fillRule: "nonzero",
    stroke: "#4A90E2",
    strokeWidth: 0.56,
    d: "M42.881 15.36H23.68c-1.766 0-3.2 1.434-3.2 3.2v3.201H43.52v15.295c1.459-.294 2.559-1.588 2.559-3.135V18.56c0-1.767-1.432-3.201-3.199-3.201z",
    opacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProjects);
export default __webpack_public_path__ + "static/media/ic-projects.7e881044.svg";
export { ForwardRef as ReactComponent };